module.exports = __webpack_public_path__ + "img/icon-command.3f00fc4d.svg";